export default "__VITE_ASSET__CCZA8Bzt__"